const modules = import.meta.glob('./*.json', { eager: true })

const messages: Record<string, any> = {}

for (const path in modules) {
  const locale = path.replace('./', '').replace('.json', '')
  const module = modules[path] as { default: any } // 类型断言
  messages[locale] = module.default // 获取模块的默认导出内容
}

export default messages
